import React from "react";
import { BodyText, VideoDeploymentContent } from "../../DeployShared";
import { WorkflowParameter } from "../../DeployCodeGenerators";

export type VideoApiContentProps = {
    workflowUrl: string;
    workspaceUrl: string;
    apiKey: string | null;
    workflowParameters: WorkflowParameter[];
    isLocalEmbedded: boolean;
    workflowConfigJSON: string | null;
    isWorkflowEditor?: boolean;
};

export function VideoApiContent({
    workflowUrl,
    workspaceUrl,
    apiKey,
    workflowParameters,
    isLocalEmbedded,
    workflowConfigJSON,
    isWorkflowEditor
}: VideoApiContentProps) {
    if (isLocalEmbedded) {
        return (
            <div className="space-y-4 p-2">
                <BodyText>
                    Roboflow offers{" "}
                    <a
                        href="https://inference.roboflow.com/managed/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Managed Cloud Compute
                    </a>{" "}
                    for video streaming. You're currently running locally;{" "}
                    <a
                        href="https://app.roboflow.com/workflows"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        connect to the cloud
                    </a>{" "}
                    for access.
                </BodyText>
            </div>
        );
    }

    return (
        <VideoDeploymentContent
            workflowUrl={workflowUrl}
            workspaceUrl={workspaceUrl}
            apiKey={apiKey}
            workflowParameters={workflowParameters}
            isLocal={false}
            workflowConfigJSON={workflowConfigJSON}
            isWorkflowEditor={isWorkflowEditor}
        />
    );
}
